let loadApplication = true;

try {
  window.localStorage.getItem("localstorage.test");
} catch (err) {
  loadApplication = false;

  if (err.message === "The operation is insecure.") {
    // Safari private mode enabled message
    document.body.innerHTML = `
      Cookies en verwante technieken dienen ingeschakeld te zijn om deze website te gebruiken.
      <br>
      Pas je browserinstellingen aan of gebruik een andere browser.
    `;
  } else {
    document.body.innerHTML = `
      Kan localStorage of cookies niet uitlezen.
      <br>
      Pas je browserinstellingen aan of gebruik een andere browser.
    `;
  }
}

if (loadApplication) {
  /**
   * First we will load all of this project's JavaScript dependencies which
   * includes React and other helpers. It's a great starting point while
   * building robust, powerful web applications using React + Laravel.
   */

  require("./bootstrap");

  /**
   * Next, we will create a fresh React component instance and attach it to
   * the page. Then, you may begin adding components to this application
   * or customize the JavaScript scaffolding to fit your unique needs.
   */

  require("./components/PaymentPortal");
}
